import { render } from "./SearchPage.vue?vue&type=template&id=50935b48&scoped=true"
const script = {}

import "./SearchPage.vue?vue&type=style&index=0&id=50935b48&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50935b48"]])

export default __exports__